/**
 * Configuration for third-party services on PUBLIC pages.
 *
 * Split out of `brand.ts` deliberately. `brand.ts` is imported by the private room (for
 * the wordmark), so anything living there ends up in the JavaScript chunk a room page
 * downloads. The ad publisher id was arriving that way — inert, loading nothing, but
 * present, which weakens the claim that ad configuration cannot reach a private page.
 *
 * Nothing in this file is imported by any module under `src/client/room/`, so the room's
 * bundle contains none of it. `tests/e2e/privacy.spec.ts` asserts that.
 */

function value(override: string | undefined, fallback: string): string {
  return override !== undefined && override !== '' ? override : fallback;
}

/** Turnstile site key. Public by design; the matching secret is a Worker secret. */
export const TURNSTILE_SITE_KEY = value(
  import.meta.env.VITE_TURNSTILE_SITE_KEY,
  '0x4AAAAAAEOjC2vkQw-QDHKx',
);

/** Google AdSense publisher id. Empty string disables every ad code path. */
export const AD_CLIENT_ID = value(import.meta.env.VITE_AD_CLIENT_ID, 'ca-pub-9915501600290498');

/** Cloudflare Web Analytics token. Empty disables the beacon. */
export const WEB_ANALYTICS_TOKEN = value(import.meta.env.VITE_WEB_ANALYTICS_TOKEN, '');
